(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topper-comparison-chart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('topper-comparison-chart')) {
    customElements.define('topper-comparison-chart', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        this.scroller = this.querySelector('[data-comparison-scroll]');
        this.navigation = this.querySelector('[data-comparison-navigation]');
        this.previousButton = this.querySelector('[data-comparison-previous]');
        this.nextButton = this.querySelector('[data-comparison-next]');
        if (!this.scroller || !this.navigation || !this.previousButton || !this.nextButton) return;

        this.onScroll = () => this.updateControls();
        this.onPrevious = () => this.scrollProducts(-1);
        this.onNext = () => this.scrollProducts(1);
        this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
        this.previousButton.addEventListener('click', this.onPrevious);
        this.nextButton.addEventListener('click', this.onNext);
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.scroller);
        this.updateControls();
      }

      updateControls() {
        const maximum = this.scroller.scrollWidth - this.scroller.clientWidth;
        const position = Math.abs(this.scroller.scrollLeft);
        this.navigation.hidden = maximum <= 1;
        this.previousButton.disabled = position <= 1;
        this.nextButton.disabled = position >= maximum - 1;
      }

      scrollProducts(direction) {
        const productHeader = this.querySelector('thead th:nth-child(2)');
        const distance = productHeader ? productHeader.getBoundingClientRect().width : this.scroller.clientWidth * 0.75;
        const sign = getComputedStyle(this.scroller).direction === 'rtl' ? -1 : 1;
        this.scroller.scrollBy({
          left: direction * sign * distance,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.resizeObserver?.disconnect();
        this.scroller?.removeEventListener('scroll', this.onScroll);
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
